import React from 'react';

import { Stack } from '@mui/material';

import ContactBarContainer from './ContactBarContainer';
import Compose from './Compose';
import MessagesContainer from './MessagesContainer';

const ChatPrimary = () => {
  // const [docWidth, setDocWidth] = useState(document.documentElement.clientWidth);

  // const onResizeDoc = () => {
  //   setDocWidth(document.documentElement.clientWidth);
  // };

  // useEffect(() => {
  //   window.addEventListener('resize', onResizeDoc);

  //   return () => {
  //     window.removeEventListener('resize', onResizeDoc);
  //   };
  // }, []);

  // console.log('docWidth', docWidth);

  return (
    <Stack
      className="CHAT-PRIMARY"
      direction="column"
      sx={{
        // this calculation makes room for the navbar on left
        // it's only shown when greater than 900px wide
        // it's also not working for the seekers' view atm
        // width: docWidth < 900 ? '100%' : 'calc(100% - 255px)',
      }}
    >
      <ContactBarContainer />
      <MessagesContainer />
      <Compose />
    </Stack>
  );
};

export default ChatPrimary;
